'use es6';

import memoize from 'transmute/memoize';
export const createCustomKey = memoize((key, objectTypeId) => `${key}_${objectTypeId}`);